import React from 'react'
import classnames from 'classnames/bind'
import {
  Dropdown,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
  DropdownSearchInput,
} from 'semantic-ui-react'
import type { DropdownProps } from 'semantic-ui-react'
import { AutomationTarget } from '../../../types'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface MobileNavProps extends AutomationTarget, DropdownProps {
  className?: string
  elmId: string
}

const MobileNav: React.FC<MobileNavProps> = ({
  elmId,
  className,
  children,
  selection = true,
  fluid = true,
  ...rest
}) => {
  return (
    <Dropdown
      className={cx('mobile-nav', className)}
      id={elmId}
      selection={selection as boolean}
      fluid={fluid}
      {...rest}
    >
      {children}
    </Dropdown>
  )
}

interface MobileNavComponent extends React.FC<MobileNavProps> {
  Divider: typeof DropdownDivider
  Header: typeof DropdownHeader
  Item: typeof DropdownItem
  Menu: typeof DropdownMenu
  SearchInput: typeof DropdownSearchInput
}

const MobileNavWithStatics: React.FC<MobileNavProps> & MobileNavComponent =
  MobileNav as React.FC<MobileNavProps> & MobileNavComponent

MobileNavWithStatics.Divider = Dropdown.Divider
MobileNavWithStatics.Header = Dropdown.Header
MobileNavWithStatics.Item = Dropdown.Item
MobileNavWithStatics.Menu = Dropdown.Menu
MobileNavWithStatics.SearchInput = Dropdown.SearchInput

export default MobileNavWithStatics
